import React, { useEffect, useState } from "react";
import { ResponsiveFunnel } from "@nivo/funnel";
import { Spin } from "antd";
import ApiService from "../../Components/apiService.js";
import { BASE_URL } from "../../Components/Constant";

const Funnel = ({ reportId }) => {
    const [funnelData, setFunnelData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!reportId) return;

        const apiServiceForRecords = new ApiService(
            `${BASE_URL}/mt_reports/${reportId}`,
            { "Content-Type": "application/json" },
            "GET"
        );

        apiServiceForRecords
            .makeCall()
            .then((response) => {
                console.log("Funnel chart data:", JSON.stringify(response));

                if (response.report && response.data.length > 0) {
                    const aggregationField = response.report.aggregation_fields?.[0] || "AnnualRevenue";
                    const groupField = response.report.group_fields?.[0] || "Name";

                    // Transform data into Funnel chart format
                    const formattedData = response.data.map((record, index) => ({
                        id: `Step ${index + 1}`,
                        value: record[aggregationField] || 0,
                        label: record[groupField] || `Step ${index + 1}`,
                    }));

                    setFunnelData(formattedData);
                } else {
                    setFunnelData([]);
                }
                setLoading(false);
            })
            .catch((err) => {
                setError(err);
                setLoading(false);
            });
    }, [reportId]);

    if (!reportId) return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', color: 'orange', fontStyle: 'bold' }}>
            Report not attached correctly.
        </div>
    );
    if (loading) return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <Spin size="large" />
        </div>
    );
    if (error) return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', color: 'red', fontStyle: 'bold' }}>
            Error: {error.message || error.error}
        </div>
    );

    return (
        <ResponsiveFunnel
            data={funnelData}
            margin={{ top: 20, right: 20, bottom: 40, left: 20 }}
            colors={['#FF5733', '#FFC300', '#36A2EB', '#4BC0C0', '#2ECC71']}
            borderWidth={2}
            borderColor={{ from: 'color', modifiers: [['darker', 0.6]] }}
            labelColor={{ from: 'color', modifiers: [['darker', 2]] }}
            valueFormat=" >-.2s"
            enableTooltip={true}
            tooltip={({ id, value, label }) => (
                <strong style={{ color: 'white', background: '#222', padding: '5px', borderRadius: '3px' }}>
                    {label}: {value}
                </strong>
            )}
            enableBeforeSeparators={true}
            enableAfterSeparators={true}
            labelPosition="inside"
            labelTextColor={{ from: 'color', modifiers: [['darker', 3]] }}
            isInteractive={true}
            motionConfig="wobbly"
        />
    );
};

export default Funnel;
